<script>
  const BASE_URL = 'https://distribution.comiru.com/api/';
  // const BASE_URL = 'http://localhost:8000/';
  export default{
    BASE_URL
  }
</script>